import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogTitle, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { getMediaCover } from '../../lib/MediasLib';
import MediaRenderer from './MediaRenderer';

const useStyles = makeStyles()((theme) => ({
  content: {
    borderRadius: theme.spacing(1),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

type Props = {
  media: any;
  show: boolean;
  onClose: () => void;
  mediaContentContain?: boolean;
};

export const MediaPreview: React.FC<Props> = ({ media, show, onClose, mediaContentContain }) => {
  const { classes } = useStyles();
  const mediaUrl = getMediaCover(media);

  return (
    <Dialog open={show} onClose={onClose} style={{ zIndex: 1302 }} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography>Pré Visualização</Typography>

        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          color="primary"
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <MediaRenderer
        type={media.type}
        src={mediaUrl}
        mediaContentContain={mediaContentContain}
        autoPlay
      />
    </Dialog>
  );
};
